// A component that opens the modal when the user is eligible

import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

export const TransactionalModernizeModal = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(({
	onClose,
	source,
	startInVideo,
}: {
	onClose: () => void;
	source: string;
	startInVideo?: boolean;
}) => {
	return <LazyModal onClose={onClose} transactional source={source} startInVideo={startInVideo} />;
});

const LazyModal = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-modernize-confluence-ipm-modal" */ './Modal/index.tsx'))
			.Modal,
});
